import { Checkbox, CheckboxState, classNames } from "@alpacahq/ui/old";

export interface RadioProps {
  name: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  label: string;
  disabled?: boolean;
}

export const Radio = ({
  name,
  isChecked,
  onChange,
  label,
  disabled,
}: RadioProps) => (
  <div className="flex items-center gap-3">
    <Checkbox
      id={name}
      state={isChecked ? CheckboxState.Checked : CheckboxState.Unchecked}
      onChange={(state) => onChange(state === CheckboxState.Checked)}
      disabled={disabled}
      className={classNames(
        !disabled ? "cursor-pointer" : "cursor-not-allowed opacity-70",
      )}
    />
    <label
      htmlFor={name}
      onClick={() => !disabled && onChange(!isChecked)}
      className={classNames(
        "text-sm",
        !disabled ? "cursor-pointer" : "cursor-not-allowed opacity-70",
      )}
    >
      {label}
    </label>
  </div>
);
